module.exports = __webpack_public_path__ + "media/images/countrysquared/jo-a9ded2f9ecc1a9fc336c4244c032d2b1.svg";